enum CardType {
  Unknown = 0,
  MasterCard = 1,
  Visa = 2,
  AmericanExpress = 3,
  Discover = 4,
  JCB = 5,
}

export default CardType;
